import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useProfile, useTokenData } from "../../../../global-account/react/index.js";
import { formatDisplayNumber } from "../../../../shared/utils/number.js";
import { Info } from "lucide-react";
import { motion } from "motion/react";
import { useEffect, useRef } from "react";
import { useConnectedWalletDisplay } from "../../hooks/useConnectedWalletDisplay.js";
import { CryptoPaymentMethodDisplay } from "./CryptoPaymentMethodDisplay.js";
import { OrderTokenAmount } from "./OrderTokenAmount.js";
import { TokenBalance } from "./TokenBalance.js";
export function CryptoPaySection(t0) {
  const $ = _c(43);
  const {
    selectedSrcChainId,
    setSelectedSrcChainId,
    selectedSrcToken,
    setSelectedSrcToken,
    srcAmount,
    setSrcAmount,
    isSrcInputDirty,
    setIsSrcInputDirty,
    selectedCryptoPaymentMethod,
    onSelectCryptoPaymentMethod,
    anyspendQuote,
    onTokenSelect,
    onShowFeeDetail,
    classes
  } = t0;
  const {
    data: srcTokenMetadata
  } = useTokenData(selectedSrcToken?.chainId, selectedSrcToken?.address);
  const {
    walletAddress
  } = useConnectedWalletDisplay(selectedCryptoPaymentMethod);
  let t1;
  if ($[0] !== walletAddress) {
    t1 = {
      address: walletAddress
    };
    $[0] = walletAddress;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: profileData
  } = useProfile(t1);
  const connectedName = profileData?.displayName;
  const appliedSrcMetadataRef = useRef(false);
  let t2;
  let t3;
  if ($[2] !== selectedSrcToken || $[3] !== setSelectedSrcToken || $[4] !== srcTokenMetadata) {
    t2 = () => {
      if (selectedSrcToken && srcTokenMetadata && !appliedSrcMetadataRef.current) {
        appliedSrcMetadataRef.current = true;
        const enhancedToken = {
          ...selectedSrcToken,
          decimals: srcTokenMetadata.decimals || selectedSrcToken.decimals,
          symbol: srcTokenMetadata.symbol || selectedSrcToken.symbol,
          name: srcTokenMetadata.name || selectedSrcToken.name,
          metadata: {
            ...selectedSrcToken.metadata,
            logoURI: srcTokenMetadata?.logoURI || selectedSrcToken.metadata.logoURI
          }
        };
        setSelectedSrcToken(enhancedToken);
      }
    };
    t3 = [srcTokenMetadata, selectedSrcToken, setSelectedSrcToken];
    $[2] = selectedSrcToken;
    $[3] = setSelectedSrcToken;
    $[4] = srcTokenMetadata;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      appliedSrcMetadataRef.current = false;
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== selectedSrcToken.address || $[9] !== selectedSrcToken.chainId) {
    t5 = [selectedSrcToken.address, selectedSrcToken.chainId];
    $[8] = selectedSrcToken.address;
    $[9] = selectedSrcToken.chainId;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  useEffect(t4, t5);
  let t6;
  if ($[11] !== anyspendQuote?.data?.currencyIn?.amountUsd || $[12] !== anyspendQuote?.data?.fee || $[13] !== classes?.balanceRow || $[14] !== classes?.container || $[15] !== classes?.inputContainer || $[16] !== classes?.label || $[17] !== classes?.paymentMethodButton || $[18] !== connectedName || $[19] !== isSrcInputDirty || $[20] !== onSelectCryptoPaymentMethod || $[21] !== onShowFeeDetail || $[22] !== onTokenSelect || $[23] !== selectedCryptoPaymentMethod || $[24] !== selectedSrcChainId || $[25] !== selectedSrcToken || $[26] !== setIsSrcInputDirty || $[27] !== setSelectedSrcChainId || $[28] !== setSelectedSrcToken || $[29] !== setSrcAmount || $[30] !== srcAmount || $[31] !== walletAddress) {
    let t7;
    if ($[33] !== anyspendQuote?.data?.fee || $[34] !== isSrcInputDirty || $[35] !== onShowFeeDetail) {
      t7 = !isSrcInputDirty && anyspendQuote?.data?.fee && onShowFeeDetail && _jsx("button", {
        onClick: onShowFeeDetail,
        className: "text-as-primary/40 hover:text-as-primary/60 transition-colors",
        children: _jsx(Info, {
          className: "h-4 w-4"
        })
      });
      $[33] = anyspendQuote?.data?.fee;
      $[34] = isSrcInputDirty;
      $[35] = onShowFeeDetail;
      $[36] = t7;
    } else {
      t7 = $[36];
    }
    let t8;
    if ($[37] !== setIsSrcInputDirty || $[38] !== setSrcAmount) {
      t8 = value => {
        setIsSrcInputDirty(true);
        setSrcAmount(value);
      };
      $[37] = setIsSrcInputDirty;
      $[38] = setSrcAmount;
      $[39] = t8;
    } else {
      t8 = $[39];
    }
    let t9;
    if ($[40] !== setIsSrcInputDirty || $[41] !== setSrcAmount) {
      t9 = value_0 => {
        setIsSrcInputDirty(true);
        setSrcAmount(value_0);
      };
      $[40] = setIsSrcInputDirty;
      $[41] = setSrcAmount;
      $[42] = t9;
    } else {
      t9 = $[42];
    }
    t6 = _jsxs(motion.div, {
      initial: {
        opacity: 0,
        y: 20,
        filter: "blur(10px)"
      },
      animate: {
        opacity: 1,
        y: 0,
        filter: "blur(0px)"
      },
      transition: {
        duration: 0.3,
        delay: 0,
        ease: "easeInOut"
      },
      className: classes?.container || "pay-section bg-as-surface-secondary border-as-border-secondary relative flex w-full flex-col gap-2 rounded-2xl border p-4 sm:p-6",
      children: [_jsxs("div", {
        className: "flex items-center justify-between",
        children: [_jsxs("div", {
          className: classes?.label || "text-as-primary/50 flex h-7 items-center gap-1.5 text-sm",
          children: ["Pay", t7]
        }), _jsx("button", {
          className: classes?.paymentMethodButton || "text-as-tertiary flex h-7 items-center gap-2 text-sm transition-colors focus:!outline-none",
          onClick: onSelectCryptoPaymentMethod,
          children: _jsx(CryptoPaymentMethodDisplay, {
            paymentMethod: selectedCryptoPaymentMethod,
            connectedAddress: walletAddress,
            connectedName
          })
        })]
      }), _jsx("div", {
        className: classes?.inputContainer,
        children: _jsx(OrderTokenAmount, {
          address: walletAddress,
          context: "from",
          inputValue: srcAmount,
          onChangeInput: t8,
          chainId: selectedSrcChainId,
          setChainId: setSelectedSrcChainId,
          token: selectedSrcToken,
          setToken: setSelectedSrcToken,
          onTokenSelect
        })
      }), _jsxs("div", {
        className: classes?.balanceRow || "flex items-center justify-between",
        children: [_jsx("div", {
          className: "text-as-primary/50 flex h-5 items-center text-sm",
          children: formatDisplayNumber(anyspendQuote?.data?.currencyIn?.amountUsd, {
            style: "currency",
            fallback: ""
          })
        }), _jsx(TokenBalance, {
          token: selectedSrcToken,
          walletAddress,
          onChangeInput: t9
        })]
      })]
    });
    $[11] = anyspendQuote?.data?.currencyIn?.amountUsd;
    $[12] = anyspendQuote?.data?.fee;
    $[13] = classes?.balanceRow;
    $[14] = classes?.container;
    $[15] = classes?.inputContainer;
    $[16] = classes?.label;
    $[17] = classes?.paymentMethodButton;
    $[18] = connectedName;
    $[19] = isSrcInputDirty;
    $[20] = onSelectCryptoPaymentMethod;
    $[21] = onShowFeeDetail;
    $[22] = onTokenSelect;
    $[23] = selectedCryptoPaymentMethod;
    $[24] = selectedSrcChainId;
    $[25] = selectedSrcToken;
    $[26] = setIsSrcInputDirty;
    $[27] = setSelectedSrcChainId;
    $[28] = setSelectedSrcToken;
    $[29] = setSrcAmount;
    $[30] = srcAmount;
    $[31] = walletAddress;
    $[32] = t6;
  } else {
    t6 = $[32];
  }
  return t6;
}